import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { OfferdbService } from '../../services/offerdb.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { recruiterModelExecption } from '../../models/exceptionalModel';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatTableFilter } from 'mat-table-filter';
// import * as _ from 'lodash'
import { RadioSelectionComponent } from '../radio-selection/radio-selection.component';

@Component({
  selector: 'app-reproposetab',
  templateUrl: './reproposetab.component.html',
  styleUrls: ['./reproposetab.component.scss'],
  standalone: false,
})
export class ReproposetabComponent implements OnInit {
  displayedColumns: string[] = [
    'candidateId',
    'name',
    'role',
    'experience',
    'lok',
    'technology',
    'puCode',
    'doj',
    'resignDate',
    'comments',
    'sentBackFrom',
    'filter',
    'download',
  ];
  dataSource1 = new MatTableDataSource<recruiterModelExecption>([]);
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  postRecNewData;
  responseRecNewData;
  empNo;
  empAttributes;
  filterEntity: any = {};
  filterType: MatTableFilter;
  showFilter: boolean = false;
  dataToDownloadApp: string = '';
  displayColumns: string[] = [
    'candidateId',
    'name',
    'role',
    'experience',
    'lok',
    'technology',
    'puCode',
    'doj',
    'resignDate',
    'comments',
    'sentBackFrom',
  ];
  displayName = [
    'Candidate ID',
    'Name of the candidate',
    'Role Designation',
    'Experience',
    'Location Of Posting',
    'Technology',
    'PU',
    'DOJ',
    'Rejection Date',
    'Comments',
    'Sent back from',
  ];
  @Input() screenName: string;
  constructor(
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    private apiData: OfferdbService,
    private date1: DatePipe,
    private router: Router,
    @Inject(MatDialog) private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadRecNewDataTable();
    this.empAttributes = localStorage.getItem('loggedInUser');
    this.empNo = JSON.parse(this.empAttributes).attributes.EmpNo[0];
    console.log('empno', this.empNo);
  }
  filterCheck(column) {
    // console.log("a");
    if (this.showFilter) {
      const filterCols = [
        'candidateId',
        'name',
        'role',
        'experience',
        'lok',
        'doj',
        'resignDate',
        'technology',
        'puCode',
      ];
      // console.log(column, filterCols.indexOf(column));

      if (filterCols.indexOf(column) != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      this.filterEntity = {};
      // this.loadExceptionDataTable()
      return false;
    }
  }

  loadRecNewDataTable() {
    let isException: any;
    if (localStorage.getItem('fresherCompHiringTypeId') == '6') {
      isException = 'N';
    } else {
      isException = 'Y';
    }
    this.postRecNewData = [
      {
        isException: isException,
        isHighest: 'Y',
        role: 'Recruiter',
        screenName: 'Recruiter',
        status: 'Pending with Recruiter',
        tabName: this.screenName,
      },
    ];
    this.ngxLoader.start();
    this.apiData.postRecruiterData(this.postRecNewData).subscribe((response) => {
      console.log('New TBD Response', response);
      response.forEach((element) => {
        for (const key in element) {
          if (element[key] == null) {
            element[key] = '';
          }
        }
      });

      this.responseRecNewData = response;
      this.dataSource1 = new MatTableDataSource<recruiterModelExecption>(this.responseRecNewData);
      this.filterType = MatTableFilter.ANYWHERE;
      this.ngxLoader.stop();
    });
  }

  downloadAppTable() {
    const AppTableArrayList = [];
    this.responseRecNewData.forEach((element) => {
      const tmp = {};
      this.displayColumns.forEach((head) => {
        tmp[head] = element[head];
      });
      AppTableArrayList.push(tmp);
    });
    this.downloadAppTableData(AppTableArrayList, this.displayName);
  }
  downloadAppTableData(data, column) {
    const dataSourceLengthApp = data.length;
    let rowDataApp = '';
    for (let i = 0; i < dataSourceLengthApp; i++) {
      let lineApp = '';
      let dataarr, splitteddata, joinedTech, year, month, day, presentDate, fullDate;
      for (const keyApp in data[i]) {
        dataarr = data[i][keyApp] + '';
        if (lineApp != '') {
          lineApp = lineApp + ',';
        }
        if (dataarr.includes(',') && keyApp === 'technology') {
          splitteddata = dataarr.split(',');
          joinedTech = splitteddata.join(';');
          lineApp = lineApp + joinedTech;
        } else if (keyApp === 'doj' || keyApp === 'resignDate') {
          presentDate = new Date(data[i][keyApp]);
          year = presentDate.getFullYear();
          month = presentDate.getMonth();
          day = presentDate.getDate();
          fullDate = day + '/' + month + '/' + year;
          lineApp = lineApp + fullDate;
          console.log('dateofjoin', fullDate);
        } else {
          lineApp = lineApp + data[i][keyApp];
        }
      }
      rowDataApp = rowDataApp + lineApp + '\r\n';
    }

    this.dataToDownloadApp = column.join(',') + '\r\n' + rowDataApp;
    if (this.dataToDownloadApp.split('\n').length - 1 >= 1) {
      const fileName = 'Re-propose offer Candidates';
      const anchorApp = document.createElement('a');
      anchorApp.href = URL.createObjectURL(new Blob([this.dataToDownloadApp], { type: 'text/csv' }));
      anchorApp.download = fileName + '.csv';
      // start download
      anchorApp.click();
    }
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource1.sort = this.sort;
  }
  RecruiterExcepPage(element) {
    if (element.indentId !== null) {
      let date = element.doj;
      date = this.date1.transform(date, 'yyyy-MM-dd').toString();
      const _indentmodal = {
        appCode: 'InTAP',
        candidateID: element.candidateId,
        dateofJoining: date,
        empNo: this.empNo,
        empSourceCode: 'InTAP',
        indentID: null,
        lastModifiedBy: this.empNo,
        stageCode: 'REOPEN',
      };
      // this.apiData.unblockIndent(element.applicationId, indentmodal).subscribe(data => {
      // })
    }
    window['selectedCandidate'] = element;
    // window['activityItem'] = element.activityId;
    window['activityItem'] = {
      activityId: element.activityId,
    };
    if (localStorage.getItem('fresherCompHiringTypeId') != '6') {
      // this.router.navigate(['offermicro/lateraloffer']);
      this.checkOfferMode();
    } else {
      this.router.navigate(['/offermicro/chinaOffer']);
    }
    //  this.router.navigate(['offermicro/lateraloffer'], { state: { RecruiterRowDetailsObj: element } })
  }
  applyFilter(filterValue: string) {
    this.dataSource1.filter = filterValue.trim().toLowerCase();
    this.dataSource1.filterPredicate = (data: recruiterModelExecption, filter: string) =>
      data.candidateId.toString().indexOf(filter) != -1;
    this.dataSource1.paginator = this.paginator;
  }
  stopPropagation(event) {
    event.stopPropagation();
    // console.log("Clicked!");
  }

  restrictSpclCharRePropose(e) {
    return this.apiData.restrictSpclCharRePropose(e);
  }

  rstrctSpclCharPasteRePropose(e) {
    return this.apiData.rstrctPasteSpclCharRePropose(e);
  }

  checkOfferMode() {
    const modeList = ['Online', 'Offline'];
    const dialogRef = this.dialog.open(RadioSelectionComponent, {
      data: modeList,
      disableClose: true,
      width: '225px',
    });
    dialogRef.afterClosed().subscribe((mode) => {
      if (mode) {
        console.log(mode);
        const actId = mode == 'Online' ? '600101' : '600102';
        window['activityItem'] = {
          activityId: actId,
        };
        this.router.navigate(['offermicro/lateraloffer']);
      }
    });
  }
}
